import { STRUCTURED_TYPES, adsTypeOf, humanText, structuredText, } from './registry/structured-display.js';
/** Статус «участия» Meta (`enroll_status`) словами. */
const ENROLL_RU = { OPT_IN: 'вкл.', OPT_OUT: 'выкл.' };
/** Значение, которое Meta/auto-ads пишут вместо true/false: 1/0, «1»/«0», OPT_IN/OPT_OUT. */
function boolish(v) {
    if (v === true || v === 1 || v === '1' || v === 'true' || v === 'OPT_IN')
        return true;
    if (v === false || v === 0 || v === '0' || v === 'false' || v === 'OPT_OUT')
        return false;
    return null;
}
/** Сырое значение — только простое (код, число): объект и список людям не показываем. */
function raw(v) {
    if (typeof v === 'string')
        return v;
    if (typeof v === 'number' || typeof v === 'boolean')
        return String(v);
    return undefined;
}
/**
 * «Ожидали / получили» сверки — словами, по полю реестра: структурные поля
 * (пол, плейсменты, улучшения креатива, …) — своими словами, вариант из
 * `options` («Предельная ставка»), `bool` — «вкл./выкл.» (Meta пишет 0/1 и
 * OPT_IN/OPT_OUT), `enroll_status` без поля — тоже «вкл./выкл.». Остальное —
 * читаемым текстом, без JSON; нет значения — «—».
 */
export function discrepancyValueRu(value, desc) {
    if (value === undefined || value === null)
        return '—';
    const type = desc ? adsTypeOf({ key: desc.key ?? '', type: desc.type }) : '';
    // «ожидали» сверки часто — готовая фраза auto-ads («нет OPT_IN»): как есть
    if (STRUCTURED_TYPES.has(type) && typeof value !== 'string') {
        const text = structuredText(type, value, desc?.options);
        if (text != null)
            return text;
    }
    const options = desc?.options ?? [];
    if (options.length > 0) {
        const b = boolish(value);
        const hit = options.find((o) => String(o.value) === String(value) || (typeof o.value === 'boolean' && o.value === b));
        if (hit)
            return hit.label;
    }
    if (desc?.type === 'bool') {
        const b = boolish(value);
        if (b != null)
            return b ? 'вкл.' : 'выкл.';
    }
    if (typeof value === 'string' && ENROLL_RU[value])
        return ENROLL_RU[value];
    if (STRUCTURED_TYPES.has(type)) {
        const text = structuredText(type, value, desc?.options);
        if (text != null)
            return text;
    }
    return raw(value) ?? humanText(value);
}
/** Сырое значение для подсказки (`title`), когда показано словами (только код / число). */
export function discrepancyRawTitle(value, shown) {
    if (value === undefined || value === null)
        return undefined;
    const r = raw(value);
    return r === undefined || r === shown ? undefined : r;
}
//# sourceMappingURL=discrepancy-values.js.map